// extracted by mini-css-extract-plugin
export var contentWrapper = "frontpage-module--contentWrapper--02b1e";
export var h1A11yHide = "frontpage-module--h1-a11y-hide--cdf9a";
export var heading = "frontpage-module--heading--8f499";
export var heroContainer = "frontpage-module--heroContainer--bd19e";
export var heroContent = "frontpage-module--heroContent--a8bdb";
export var heroImage = "frontpage-module--heroImage--d751c";
export var subHeading = "frontpage-module--subHeading--2c858";